import { getArray } from '../index'

export default {
  list: (params) => getArray('agreements', params)
}
